<div class="modal-header">
  <h4 class="modal-title h5" translate>Tile configuration</h4>
  <button type="button" class="close" aria-label="Close" (click)="onCloseModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="machine-card">
    <div class="machine-card-header">
      <div class="machine-card-icon traffic-light offline">
        <img [src]="machineIcon" alt="">
      </div>
      <div class="title-wrapper">
        <strong class="title" [innerText]="machineName"></strong>
        <span class="subtitle" translate [innerText]="machineType"></span>
      </div>
    </div>
    <div class="machine-card-content">
      <div class="table-values">
        @if (showContents) {
          <table>
            @for (row of [0,1,2,3]; track row) {
              <tr>
                @for (col of [0,1]; track col) {
                  <td class="values-row">
                    <ng-select [disabled]="!isAdminOrSuperAdmin"
                      [(ngModel)]="configuration.dashboardRowsMap[row].itemsMap[col].signalName"
                      [items]="signals"
                      [searchable]="true"
                      (clear)="onSignalClear(row, col)"
                      (change)="onSignalChange(row, col, $event)"
                      placeholder="{{'Select signal'|translate}}"
                      bindLabel="label"
                      bindValue="name"
                      required="true">
                      <ng-template let-item="item" ng-label-tmp>
                        <span [innerText]="item.label | translate"></span>
                      </ng-template>
                      <ng-template let-item="item" ng-option-tmp>
                        <span [innerText]="item.label | translate"></span>
                      </ng-template>
                    </ng-select>
                  </td>
                }
              </tr>
            }
          </table>
        }
      </div>
    </div>
    <div class="machine-card-footer">
      <div class="row mb-2 align-items-center">
        <div class="col-auto">
          <div class="image-placeholder">
            <button class="btn btn-xs btn-outline-danger"
              title="{{'Delete fallback image' | translate}}"
              (click)="onImageDelete()">
              <span class="fa-solid fa-trash"></span>
            </button>
            <img [src]="rawPlaceholderImage" alt="">
          </div>
        </div>
        <div class="col">
          <span class="h6 mb-1 d-block" translate>Optional Fallback Image</span>
          <small class="mb-2 d-block" translate>This image shows up when no gateway is configured.</small>
        </div>
      </div>
      <div class="custom-file">
        <input type="file"
          class="custom-file-input"
          id="customFile" (change)="onImageChange($event)"
          accept="image/*">
          <label class="custom-file-label" for="customFile">
            @if (selectedFileName==='') {
              <span translate>Choose file</span>
            }
            @if (selectedFileName!=='') {
              <span [innerText]="selectedFileName"></span>
            }
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary"
      (click)="onCloseModal()" translate>Cancel
    </button>
    <button type="button" class="btn btn-primary"
      [disabled]="!isAdminOrSuperAdmin"
      (click)="onSaveChanges()" translate>Save
    </button>
  </div>
